(function() {

    "use strict";

    angular
        .module("harriApp")
        .service("TLEmployerSettingsDataService", TLEmployerSettingsDataService);

    TLEmployerSettingsDataService.$inject = ['$q', 'TeamScheduleService', 'userPermissions', 'brandServices','hUser'];

    /**
     * @namespace TLEmployerSettingsDataService
     * @param $q
     * @param TeamScheduleService
     * @param userPermissions
     * @param brandServices
     * @returns {TLEmployerSettingsDataService}
     * @constructor
     */
    function TLEmployerSettingsDataService($q, TeamScheduleService, userPermissions, brandServices, hUser) {
        var service = this;

        var tlSettingsPermissions = [
            userPermissions.PERMISSIONS.MANAGE_GENERAL_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_SHIFTS_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_BRAND_PERMISSIONS,
            userPermissions.PERMISSIONS.MANAGE_FORECASTING_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_FORECASTING_TEMPLATE,
            userPermissions.PERMISSIONS.MANAGE_ABSENCES,
            userPermissions.PERMISSIONS.MANAGE_BREAKS_SETTINGS,
            userPermissions.PERMISSIONS.VIEW_BREAKS_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_FWW_PENALTIES_SETTING,
            userPermissions.PERMISSIONS.MANAGE_LOGBOOK_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_PUBLISH_RESTRICTION_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_TEAMLIVE_NOTIFICATIONS_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_EMPLOYEE_QUESTIONNAIRE_NOTIFICATION,
            userPermissions.PERMISSIONS.ADVANCED_PDS_ACCESS,
            userPermissions.PERMISSIONS.MANAGE_PAYSHEET_PAYRUN,
            userPermissions.PERMISSIONS.MANAGE_MEDIA_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_MINOR_RULES_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_SCHOOL_CALENDAR_TEMPLATES_SETTINGS,
            userPermissions.PERMISSIONS.MANAGE_TEAMHUB_SETTINGS,
            userPermissions.PERMISSIONS.EDIT_PAY_RULES_SETTINGS,
        ];

        var GFE_APPLIED_CITES = [ 'NY', 'PL' ];

        service.canShowTLSettings = (brandId) => {
            const deferred = $q.defer();

            if (hUser.isTopLevelContext()) {
                deferred.resolve(false);
                return deferred.promise;
            }

            $q.all({
                isTeamSchedulingServiceEnabled: brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brandId),
                policyParser: userPermissions.getBrandPolicy(brandId),
            })
                .then(({isTeamSchedulingServiceEnabled, policyParser}) => {
                    if (
                        isTeamSchedulingServiceEnabled &&
                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM)
                    ) {
                        const innerPromises = {
                            'policyParser': userPermissions.getBrandPolicy(brandId),
                            'isGoodFaithEstimateIncidentsTrackingEnabled': brandServices.check(brandServices.SERVICES.GFE_INCIDENTS_TRACKING, brandId),
                        };

                        $q.all(innerPromises)
                            .then(function (res) {
                                const policyParser = res['policyParser'];
                                const hasAnySettingsPermissions = policyParser.hasAny(tlSettingsPermissions);
                                const isGFEIncidentsTrackingEnabled = res['isGoodFaithEstimateIncidentsTrackingEnabled'];

                                if (isGFEIncidentsTrackingEnabled) {
                                    GoodFaithEstimateAPI.getGFEBrandSettings(brandId)
                                        .then(function (settings) {
                                            const GFEBrandSettings = settings['settings'] || {};
                                            const appliedCity = GFE_APPLIED_CITES.find((city) => {
                                                return GFEBrandSettings.state === city;
                                            });
                                            deferred.resolve(hasAnySettingsPermissions || !!appliedCity);
                                        });
                                } else {
                                    deferred.resolve(hasAnySettingsPermissions);
                                }
                            });
                    } else {
                        deferred.resolve(false);
                        return deferred.promise;
                    }
                });

            return deferred.promise;
        };

        service.getBrandActivePositions = function () {
            var deferred = $q.defer();

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    TeamAPI
                        .getBrandActivePositionCategories(brand.id, true)
                        .then(function (positions) {
                            deferred.resolve(positions);

                        }, function (err) {
                            console.error(err);
                            deferred.reject(err);
                        });
                });

            return deferred.promise;
        };

        /**
         * @public
         * @type function
         * @memberOf TLEmployerSettingsDataService#getBrandShiftTemplates
         * @return {Object} promise
         */
        service.getBrandShiftTemplatesSettings = function () {
            var deferred = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    TeamScheduleAPI.getBrandShiftTemplatesSettings(brand.id)
                        .then(function (data) {
                            deferred.resolve(data && data.templates);
                        }, function (err) {
                            console.error(err);
                            deferred.reject(err);
                        });
                });

            return deferred.promise;
        };

        service.getBrandShiftTemplates = function () {
            var deferred = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    TeamScheduleAPI.getBrandShiftTemplates(brand.id)
                        .then(function (data) {
                            deferred.resolve(data && data.templates);
                        }, function (err) {
                            console.error(err);
                            deferred.reject(err);
                        });
                });

            return deferred.promise;
        };

        /**
         * @public
         * @type function
         * @memberOf TLEmployerSettingsDataService#updateBrandShiftTemplates
         * @param {Array} shiftTemplates
         * @return {Object} promise
         */
        service.updateBrandShiftTemplates = function (shiftTemplates) {
            var deferred = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    TeamScheduleAPI.updateBrandShiftTemplatesSettings(brand.id, shiftTemplates)
                        .then(function (res) {
                            deferred.resolve(res);
                        },
                        function (err) {
                            console.error(err);
                            deferred.reject(err);
                        });
                });

            return deferred.promise;
        };

        service.getEmailsAndPushNotificationsSettings = function () {
            var deferred = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    NotificationCenterAPI
                        .getEmailsAndPushNotificationsSettings(brand.id)
                        .then(function (res) {
                            deferred.resolve(res);

                        }, function (err) {
                            console.error(err);
                            deferred.reject(err);
                        })
                });

            return deferred.promise;
        };

        service.updateEmailsAndPushNotificationsSettings = function (notificationSettings) {
            var deferred = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    NotificationCenterAPI
                        .updateEmailsAndPushNotificationsSettings(brand.id, notificationSettings)
                        .then(function (res) {
                            deferred.resolve(res);

                        }, function (err) {
                            console.error(err);
                            deferred.reject(err);
                        })
                });

            return deferred.promise;
        };

        service.getScheduleSubmissionsNotifyAdminsSettings = function () {
            var deferred = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {

                    TeamScheduleAPI.getScheduleSubmissionsNotifyAdminsSettings(brand.id)
                        .then(function (res) {
                            deferred.resolve(res);
                        })
                        .catch(function (err) {
                            console.error(err);
                            deferred.reject(err);
                        });
                });

            return deferred.promise;
        };

        service.updateOvernightShiftSettings = function (overnightShiftSettings) {
            service.overnightShiftSettings = overnightShiftSettings || [];
        };

        service.checkOvernightShiftsSettings = function (date) {
            for (var i = service.overnightShiftSettings.length - 1; i >= 0; i--) {
                var shiftStartDate = new Date(service.overnightShiftSettings[i].start_date).getTime();

                if (new Date(date).getTime() >= shiftStartDate) {
                    return service.overnightShiftSettings[i].status === "ACTIVE";
                }
            }
            return false;
        };

        service.isFullBusinessDayCoverage = function (fromTime, toTime, businessDay, includeExtension) {
            var openTime = businessDay.open_time;
            var closeTimeWithExtension = businessDay.close_time + businessDay.close_time_extension;
            var closeTimeWithoutExtension = businessDay.close_time;
            var closeTime;
            if (businessDay.close_time <= openTime) {
                if (includeExtension) {
                    closeTime = closeTimeWithExtension + (24 * 60 * 60);
                } else {
                    closeTime = closeTimeWithoutExtension + (24 * 60 * 60);
                }
            }

            return (
                fromTime === businessDay.open_time &&
                toTime === closeTime
            );
        };

        service.calculateAllowedBackdatedWeekStartDateBasedOnPaysheets = function (brand) {
            var deferred = $q.defer();

            PerformanceAggregatorAPI.getLatestClosedPayPeriod(brand.id, 'HOURLY', "CLOSED,SENT")
                .then(function (response) {
                    var paysheets = response.paysheets;
                    var currentDate = moment().startOf('day');
                    var allowedStartOfWeekDate = Utils.getWeekStart(currentDate, brand.startDayOfWeek);
                    var latestPaysheet = paysheets[0];

                    for (var i in paysheets) {
                        var paysheet = paysheets[i];
                        var end_date = moment(paysheet.end_date);
                        var previous_end_date = moment(latestPaysheet.end_date);

                        if (end_date.isSameOrAfter(previous_end_date)) {
                            latestPaysheet = paysheets[i];
                        }
                    }
                    if (latestPaysheet) {
                        var backdatedWeek = angular.copy(allowedStartOfWeekDate);
                        for (var j = 0; j < 3; j++) {
                            var latest_end_date = moment(latestPaysheet.end_date);
                            backdatedWeek.subtract(7, 'days');
                            if (latest_end_date.isSameOrAfter(backdatedWeek)) {
                                var startDateOfNextPaySheet = latest_end_date.clone().add('1', 'day');
                                if (startDateOfNextPaySheet.isBefore(allowedStartOfWeekDate))
                                {
                                    allowedStartOfWeekDate = startDateOfNextPaySheet;
                                }
                                break;
                            } else {
                                allowedStartOfWeekDate = angular.copy(backdatedWeek);
                            }
                        }
                    } else {
                        allowedStartOfWeekDate.subtract(21, 'days');
                    }

                    deferred.resolve(allowedStartOfWeekDate.format('MMM DD, YYYY'));
                })
                .catch(function (err) {
                    console.error(err);
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        return service;
    }

})();